/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useMemo, useState, useRef, useContext } from "react";
import "./Notification.scss";
import {
  ContextMenuLogo,
  DangerIcon,
  ImportantIcon,
  UpdateIcon,
  WarningIcon,
} from "../../components/Icons/CheckOutLogo";
import ThemeContext from "../../ThemeContext";

interface NotiCardProps {
  data: {
    type: string;
    title: string;
    text: string;
    time: string;
    isread: boolean;
  };
  isActive: boolean;
}

const NotiCard: React.FC<NotiCardProps> = ({ data, isActive }) => {
  const { type, title, text, time } = data;
  const themes = useContext(ThemeContext);
  const renderIcon = (type: any) => {
    switch (type) {
      case "warning":
        return <WarningIcon />;
      case "update":
        return <UpdateIcon />;
      case "danger":
        return <DangerIcon />;
      case "important":
        return <ImportantIcon />;
    }
  };
  return (
    <div
      className={`NotiCardWrapper ${isActive ? "activeN" : "inactive"} ${
        data.isread ? "read" : "unread"
      }`}
    >
      <div className="icon1">{renderIcon(data.type)}</div>
      <div className="content">
        <div className="heading">{title}</div>
        <div className="text">
          {text?.length && text.length > 20
            ? text?.substring(0, 20) + "..."
            : text}
        </div>
        <div className="time">{time}</div>
      </div>
      <div className="icon2">
        <ContextMenuLogo color={"#8B97A3"} />
      </div>
    </div>
  );
};

export default NotiCard;
